import { Box, IconButton, Typography } from "@mui/material";

import { MinusIcon, PlusIcon } from "lucide-react";

import { useMonitoringStore } from "../../monitoringStore";

export function ScaleSelector() {
  const scale = useMonitoringStore((s) => s.scale);
  const setScale = useMonitoringStore((s) => s.setScale);

  return (
    <Box
      sx={{
        display: "flex",
        gap: 1,
        alignItems: "center",
        border: 1,
        padding: 0.5,
        borderRadius: 1,
        borderColor: "divider",
      }}
    >
      <IconButton
        color={"neutral.moderate"}
        size={"small"}
        disabled={scale === 1}
        onClick={() => setScale(scale - 1)}
      >
        <MinusIcon />
      </IconButton>
      <Typography variant={"bodySmallRegular"}> {scale * 10 + "%"}</Typography>
      <IconButton
        color={"neutral.moderate"}
        size={"small"}
        disabled={scale === 50}
        onClick={() => setScale(scale + 1)}
      >
        <PlusIcon />
      </IconButton>
    </Box>
  );
}
